import { render, staticRenderFns } from "./PurchasePayTdsView.vue?vue&type=template&id=fdca0538&scoped=true"
import script from "./PurchasePayTdsView.vue?vue&type=script&lang=js"
export * from "./PurchasePayTdsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdca0538",
  null
  
)

export default component.exports